import type React from "react";
import { twJoin } from "tailwind-merge";

import { selectionControlBoxClassName, SelectionControlGlyph } from "./SelectionControl";

export type RadioProps = {
  name: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
  "data-testid"?: string;
  defaultChecked?: boolean;
  ref?: React.Ref<HTMLInputElement>;
  value: string;
  checked?: boolean;
} & (
  | {
      label?: never;
    }
  | {
      label: string;
    }
);

export function Radio({ ref, label, disabled, ...props }: RadioProps): React.ReactNode {
  const radioInput = (
    <div className="relative inline-flex size-selection-control shrink-0">
      <input
        {...props}
        disabled={disabled}
        className="peer absolute z-10 size-full opacity-0 disabled:pointer-events-none"
        ref={ref}
        type="radio"
      />
      <div className={twJoin(selectionControlBoxClassName, "rounded-full")}>
        <SelectionControlGlyph />
      </div>
    </div>
  );

  if (!label) {
    return radioInput;
  }

  return (
    <label className="inline-flex shrink-0 items-center gap-x-space-sm">
      {radioInput}
      <span className={twJoin(disabled && "text-text-disabled")}>{label}</span>
    </label>
  );
}
